import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "./image/Microsoft-Excel.png";
import { getAdminlogin } from "./APIs/CreateSocietyApi"
import { CSVLink } from "react-csv";
import Sidebar from './Sidebar';
import Header from './Header';
import { FiActivity, FiDownload, FiSearch } from "react-icons/fi";

const AllLoginAdmin = () => {
  const [loginAdmin, setLoginAdmin] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const headers = [
    { label: "Society Name", key: "society" },
    { label: "Admin", key: "adminName" },
    { label: "Mobile No", key: "adminPhoneNo" },
    { label: "Email ID", key: "adminEmail" },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const formatTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  useEffect(() => {
    const loadLoginAdmin = async () => {
      try {
        const data = await getAdminlogin();
        setLoginAdmin(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error loading login logs:", error);
      } finally {
        setLoading(false);
      }
    };
    loadLoginAdmin();
  }, []);

  const filteredLogs = loginAdmin.filter(log =>
    log?.admin_email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="flex min-h-screen bg-bg-primary text-text-main font-satoshi transition-colors duration-300">
      <Sidebar />

      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header />

        <div className="flex-1 overflow-y-auto p-6 md:p-8 relative">

          {/* Background Elements */}
          <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden opacity-30">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-sky-900/10 rounded-full blur-[120px]"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto space-y-6">

            {/* Actions Toolbar */}
            <div className="flex flex-col md:flex-row justify-between items-end md:items-center gap-4 border-b border-border pb-6">
              <div>
                <h1 className="text-3xl font-clash font-bold text-text-main mb-1 flex items-center gap-3">
                  Access Logs <FiActivity className="text-signal-orange" />
                </h1>
                <p className="text-text-muted text-sm">Monitor system entry and exit activity</p>
              </div>

              <div className="flex items-center gap-3">
                <div className="relative group">
                  <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted group-focus-within:text-signal-orange transition-colors" />
                  <input
                    type="text"
                    placeholder="Search by email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2 bg-bg-secondary border border-border rounded focus:border-signal-orange focus:outline-none text-sm w-64 transition-all text-text-main placeholder:text-text-muted"
                  />
                </div>
                <CSVLink data={loginAdmin} headers={headers} filename="login-logs.csv">
                  <button className="flex items-center gap-2 px-4 py-2 bg-bg-secondary hover:bg-bg-tertiary border border-border rounded text-sm font-medium transition-all group text-text-main">
                    <FiDownload className="group-hover:text-signal-lime" />
                    <span>Export</span>
                  </button>
                </CSVLink>
              </div>
            </div>

            {/* List Content */}
            <div className="bg-bg-secondary rounded border border-border overflow-hidden shadow-sm">
              {/* Header Row */}
              <div className="grid grid-cols-4 gap-4 p-4 border-b border-border bg-bg-tertiary/50 text-xs font-bold text-text-muted uppercase tracking-wider">
                <div>Admin Identity</div>
                <div>Date</div>
                <div>Login Time</div>
                <div className="text-right">Session Status</div>
              </div>

              {/* Rows */}
              <div className="divide-y divide-border">
                {loading ? (
                  <div className="p-8 text-center text-text-muted animate-pulse">Loading access logs...</div>
                ) : filteredLogs.length === 0 ? (
                  <div className="p-8 text-center text-text-muted">No logs found matching your search.</div>
                ) : (
                  filteredLogs.map((item, index) => (
                    <div key={index} className="grid grid-cols-4 gap-4 p-4 items-center hover:bg-bg-primary transition-colors group">
                      <div className="font-medium text-text-main group-hover:text-signal-orange transition-colors truncate" title={item.admin_email}>
                        {item.admin_email}
                      </div>
                      <div className="text-sm text-text-muted">
                        {formatDate(item.login_at)}
                      </div>
                      <div className="text-sm text-text-muted font-mono">
                        {formatTime(item.login_at)}
                      </div>
                      <div className="text-right">
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide bg-green-500/10 text-green-500 border border-green-500/20">
                          <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
                          Logged In
                        </span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default AllLoginAdmin;
